
import { Component, Vue, Ref } from 'vue-property-decorator'
import { CommonService } from '@/services'
import ScrollTo from '@/components/scroll_to/index.vue'
import ScrollToType from '@/components/scroll_to/type'
import TableList from '../components/article_table.vue'

const articleTypes = {
    all: {
        name: '全部文章',
        id: 'all'
    },
    recommend: {
        name: '推荐文章',
        id: 'recommend'
    },
    top: {
        name: '置顶文章',
        id: 'top'
    }
}

const paramsMap = new Map<string, any>([
    ['all', ''],
    ['recommend', { recommend: 1 }],
    ['top', { top: 1 }]
])

@Component({
    components: {
        ScrollTo,
        TableList
    }
})
export default class extends Vue {
    @Ref('scrollRef') private scrollEl!: ScrollToType
    private pageSize = 15
    private pageIndex = 1
    private pageTotal = 0
    private list: any[] = []
    private typeList: any[] = []
    private isLoading = true
    private firstInit = true
    private typeId = -1
    private pathName = ''
    private articleType = 'all'
    private articleTypes = articleTypes

    async mounted() {
        this.typeId = +this.$route.query.type
        this.pathName = this.$route.name || ''
        
        await this.getTypeList()
        await this.getList()
        if (this.firstInit) {
            this.isLoading = false
        }
        this.firstInit = false
    }

    async getTypeList() {
        const result = await CommonService.getIArticleTypes({})
        if (result.status === 200) {
            this.pageTotal = result.data.length
            this.typeList = result.data
        }
    }

    async getList() {
        this.isLoading = true
        const params = {
            type_id: this.typeId ? this.typeId : undefined,
            page_index: this.pageIndex,
            page_size: this.pageSize
        }
        const curType = paramsMap.get(this.articleType)
        curType !== 'all' && Object.assign(params, curType)
        const result = await CommonService.getIArticleList(params)
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            this.list = result.data.list
        }
        if (!this.firstInit) {
            this.isLoading = false
        }
    }

    // 分页
    onPageChange(curPage: number) {
        this.pageIndex = curPage
        this.scrollEl.scrollToTop(this.getList)
    }

    // 删除
    private onDelete(article: any) {
        this.$confirm('你正在删除文章, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            this.deleteArticle(article)
        })
    }

    async deleteArticle(article: any) {
        const params = { id: article.id }
        const result = await CommonService.deleteIArticle(params)
        if (result.status === 200) {
            this.list.splice(this.list.indexOf(article), 1)
            --this.pageTotal
            this.$message({
                type: 'success',
                message: '删除成功',
                showClose: true
            })
            return
        }
        this.$message({
            type: 'error',
            message: result.message || '发生错误, 请稍后再试',
            showClose: true
        })
    }

    onChange() {
        this.getList()
    }

    onArticleTypeChange() {
        this.getList()
    }
}
